import Reveal from "@/components/base/Reveal";
import { genres } from "@/mocks/siteData";

interface GenresProps {
  onPick: (genre: string) => void;
}

export default function Genres({ onPick }: GenresProps) {
  return (
    <section id="genres" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
                <span className="w-6 h-px bg-primary-400"></span>
                题材分类
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                八种归类的角度，决定你从哪里开始看
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                片单同时按题材与地区两个维度做了归类。点击任意分类，会带着该条件跳到上方的影片片单，并即时过滤出对应内容；
                也可以回到片单自行组合筛选。
              </p>
            </div>
            <div className="shrink-0 inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-accent-100 text-accent-900 text-sm">
              <i className="ri-cursor-line text-lg" aria-hidden="true"></i>
              点击分类即可筛选片单
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {genres.map((g, idx) => (
            <Reveal key={g.id} delay={Math.min(idx, 5) * 60}>
              <button
                onClick={() => onPick(g.name)}
                className="group w-full h-full text-left bg-background-100 rounded-lg border border-background-200 p-4 md:p-5 hover:border-primary-300 hover:bg-background-200/60 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-700 transition-colors">
                    <i className={`${g.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <span className="font-heading text-xl font-bold text-foreground-300 group-hover:text-accent-600 transition-colors">
                    {g.count}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">{g.name}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">{g.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                  筛选该分类
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}